/* eslint-disable react-hooks/exhaustive-deps */
import Button from "../Button";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { toPersianNum } from "utils/helpers";
import style from "./style.module.scss";
import { BarcodeReceivingModalProps } from "./BarcodeReceivingModal.props";

const BarcodeReceivingModal = React.memo<BarcodeReceivingModalProps>(
    ({ show, hideModal, foodData, receivingData, setReceivingData }) => {
        const [count, setCount] = useState(0);
        const [foodIndex, setFoodIndex] = useState(-1);
        const [orderCount, setOrderCount] = useState(0);

        useEffect(() => {
            if (show) {
                // 1.
                // find food (BASE ON API RES.)
                let tempFoodIndex;

                tempFoodIndex = receivingData.receiving_items.findIndex(
                    (element) => {
                        return (
                            foodData.branch_id === element.branch_id &&
                            foodData.food_id === element.food_id
                        );
                    }
                );

                if (tempFoodIndex !== -1) {
                    setFoodIndex(tempFoodIndex);
                }
            }
        }, [show]);

        useEffect(() => {
            if (show && foodIndex !== -1) {
                setOrderCount(
                    receivingData.receiving_items[foodIndex].order_count
                );
            }
        }, [foodIndex]);

        const handleIncrease = () => {
            setCount(count + 1);
        };

        const handleDecrease = () => {
            if (count !== 0) {
                setCount(count - 1);
            }
        };

        const handleClick = (itemCount: number) => {
            setCount(itemCount);
        };

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            if (!Number.isNaN(event.target.value))
                setCount(Number(event.target.value));
        };

        const handleSubmit = () => {
            if (foodIndex !== -1) {
                // 2.
                // get inputs data

                // 3.
                // change dataObject
                receivingData.receiving_items[foodIndex].receiving_count +=
                    count;
                // 4.
                // call setDataObject
                setReceivingData(receivingData);
            }

            // 5.
            // close modal
            hideModal();

            setCount(0);
        };

        return (
            <Modal
                show={show}
                onHide={() => {
                    hideModal();
                }}
                centered
                dir="rtl"
                className="rtl"
                aria-labelledby="barcode-modal"
                data-testid="ReceivingModal"
            >
                <Modal.Header
                    className="border-0"
                    closeButton
                    data-testid="ReceivingModal__closeButton"
                >
                    <Modal.Title
                        className={`${style.title}`}
                        id="barcode-modal"
                    >
                        <span>اطلاعات بارکد اسکنر</span>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body data-testid="ReceivingModal__body">
                    <div className={`${style.container}`}>
                        <div
                            className={`pl-3 pr-3 mb-2 d-flex justify-content-between align-items-center 
                                ${style.item}
                                `}
                        >
                            <span>غذا</span>
                            <span data-testid="ReceivingModal__foodName">
                                {foodData?.food}
                            </span>
                        </div>
                        <div
                            className={`pl-3 pr-3 mb-4 d-flex justify-content-between align-items-center 
                                ${style.item}
                                `}
                        >
                            <span>وندور</span>
                            <span data-testid="ReceivingModal_vendorName">
                                {foodData?.vendor}
                            </span>
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label className="">تعداد</Form.Label>
                            <div className="position-relative d-flex jusitfy-content-center align-items-center">
                                <Form.Control
                                    className={`text-center`}
                                    type="number"
                                    min="0"
                                    onChange={handleChange}
                                    value={count}
                                    data-testid="ReceivingModal__quantity"
                                />
                                <button
                                    className={`${style.addButton} ${style.countButton}`}
                                    onClick={handleIncrease}
                                    data-testid="ReceivingModal__increaseButton"
                                >
                                    <span>+</span>
                                </button>
                                <button
                                    className={`${style.subtractButton} ${style.countButton}`}
                                    onClick={handleDecrease}
                                    data-testid="ReceivingModal__decreaseButton"
                                >
                                    <span>&minus;</span>
                                </button>
                            </div>
                        </Form.Group>

                        <div
                            className="pt-1 pb-1 pr-3 pl-3 d-flex justify-content-between"
                            data-testid="ReceivingModal__defaultQuantities"
                        >
                            <button
                                className={`${style.suggestItem}`}
                                onClick={() => {
                                    handleClick(orderCount);
                                }}
                            >
                                <span>{toPersianNum(orderCount)}</span>
                            </button>
                            <button
                                className={`
                                    ${style.suggestItem}
                                    ${count === 20 ? style.active : ""}
                                `}
                                onClick={() => {
                                    handleClick(20);
                                }}
                            >
                                <span>{toPersianNum(20)}</span>
                            </button>
                            <button
                                className={`
                                ${style.suggestItem}
                                ${count === 15 ? style.active : ""}
                            `}
                                onClick={() => {
                                    handleClick(15);
                                }}
                            >
                                <span>{toPersianNum(15)}</span>
                            </button>
                            <button
                                className={`
                                ${style.suggestItem}
                                ${count === 10 ? style.active : ""}
                            `}
                                onClick={() => {
                                    handleClick(10);
                                }}
                            >
                                <span>{toPersianNum(10)}</span>
                            </button>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer
                    className="border-0 flex-nowrap justify-content-center"
                    data-testid="ReceivingModal__footer"
                >
                    <Button
                        className={`is-green solid font-weight-normal ${style.button}`}
                        btnText="ثبت"
                        handleClick={handleSubmit}
                    />
                </Modal.Footer>
            </Modal>
        );
    }
);

export default BarcodeReceivingModal;
